import React, {useEffect, useState} from "react";

const Default = ({value, center}) => {
    const [valueComponent, setValue] = useState("")

    useEffect(() => {
        if (value && typeof value === "object") {
            setValue(value.name)
        } else {
            setValue(value)
        }
    }, []);

    return (
        <span className={`truncate cell-custom flex ${center ? "justify-center p-0" : ""}`}>{valueComponent}</span>
    );
}

export default Default;